import {
  useNavigate as useRRNavigate,
  useResolvedPath,
  NavigateOptions,
} from 'react-router-dom'
import { useIsMFE } from '@/contexts/mfe-context'
import { useCallback } from 'react'

const LOCALE_RE = /^\/(ar|en)(\/|\?|$)/
// react-router resolves every string as a path relative to the current route,
// so an absolute URL (payment gateway, identity provider) gets appended to it
// instead of being opened. Those targets live outside the SPA.
const EXTERNAL_URL_RE = /^(?:[a-z][a-z\d+\-.]*:|\/\/)/i

export function useNavigate() {
  const navigate = useRRNavigate()
  const isMFE = useIsMFE()
  const { pathname: basePath } = useResolvedPath('/')

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to)
        return
      }

      if (EXTERNAL_URL_RE.test(to)) {
        window.location.assign(to)
        return
      }

      if (isMFE) {
        const base = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath
        if (base && to.startsWith(base)) {
          const stripped = to.slice(base.length)
          navigate(stripped || '/', options)
          return
        }
        if (LOCALE_RE.test(to)) {
          const withoutLocale = to.replace(LOCALE_RE, '/$2')
          navigate(withoutLocale, options)
          return
        }
      }

      navigate(to, options)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [navigate, isMFE, basePath]
  )
}
